import React from 'react';
import ReactDOM from 'react-dom/client';
import 'react-toastify/dist/ReactToastify.css';
import 'react-image-lightbox/style.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import 'aos/dist/aos.css';
import "react-datepicker/dist/react-datepicker.css";
import "/node_modules/ckeditor5/dist/ckeditor5.css";
// css 순서에 따라 덮어쓰기 위해서 여기서 한번 불러줌
import 'bf-library/dist/bf-library.esm.css';
import './scss/index.scss';

import 'moment/locale/ko';
// import 'chart.js/auto';

import { Root } from './Root';
import reportWebVitals from './reportWebVitals';

import { registerLocale, setDefaultLocale } from "react-datepicker";
import ko from 'date-fns/locale/ko';
registerLocale('ko', ko);
setDefaultLocale(ko);

// chart를 사용할때 register에 등록을 해줘야하는데 auto는 알아서 해주는건가 모두 해주는 것인가?
// import {Chart, CategoryScale, ArcElement, } from 'chart.js'
// Chart.register([CategoryScale, ArcElement]);
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  // <React.StrictMode>
  <Root />
  // </React.StrictMode>
);

reportWebVitals();